import { getMessages } from '../../../../../../../../store/constants';

export const CLASS_BOARD_ATTACHMENTS = 'board-attachments';
export const LOADING_PERCENT = 'LOADING_PERCENT';

export const CLASS_BOARD_ATTACHMENTS_LOADER_TITLE = getMessages().getText('aside_panel.tab.attachments_loader_title');
export const CLASS_BOARD_ATTACHMENTS_LOADER_TEXT = getMessages().getText('aside_panel.tab.attachments_loader_text');
